module.exports = __webpack_public_path__ + "static/images/share2.5c82fa3.png";